var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { FormSettingsContext } from "../../utils";
import { SpacingUnit } from "./spacingUnit";
import copy from "fast-copy";
import { useAppSelector } from "@/hooks/store";
export var SpacingEditor = function (_a) {
    var getType = _a.getType, type = _a.type;
    var fontOpacity = useAppSelector(function (state) { return state.theme; }).fontOpacity;
    var _b = useContext(FormSettingsContext), settings = _b.settings, editedSettings = _b.editedSettings;
    var current = settings.currentComponent || {};
    var theme = (fontOpacity === null || fontOpacity === void 0 ? void 0 : fontOpacity.detail_view_fields) || {};
    function resolveValue(custom, themeValue) {
        if (custom !== undefined && custom !== null && custom !== "") {
            return custom;
        }
        if (themeValue !== undefined && themeValue !== null && themeValue !== "") {
            return themeValue;
        }
        return "";
    }
    var nullValue = {
        top: "",
        right: "",
        bottom: "",
        left: "",
    };
    var updateFromParams = function (metaData) {
        var _a, _b, _c, _d;
        var value = (((_b = (_a = metaData.settings) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.spacing) &&
            ((_d = (_c = metaData.settings) === null || _c === void 0 ? void 0 : _c.styles) === null || _d === void 0 ? void 0 : _d.spacing[type])) ||
            nullValue;
        var top = value.top || "";
        var right = value.right || "";
        var bottom = value.bottom || "";
        var left = value.left || "";
        value.top = top;
        value.right = right;
        value.bottom = bottom;
        value.left = left;
        return value;
    };
    var _c = useState(nullValue), editedValue = _c[0], setEditedValue = _c[1];
    useEffect(function () {
        setEditedValue(updateFromParams(copy(current)));
    }, [settings.selected]);
    function getValue(value, getValue) {
        var _a;
        setEditedValue(__assign(__assign({}, editedValue), (_a = {}, _a[value] = getValue, _a)));
    }
    useEffect(function () {
        // Passer les valeurs modifiées vers parent
        getType(type, editedValue);
    }, [editedValue]);
    var effectiveTop = resolveValue(editedValue.top, type === "padding" ? theme.pt : theme.mt);
    var effectiveRight = resolveValue(editedValue.right, type === "padding" ? theme.pr : theme.mr);
    var effectiveBottom = resolveValue(editedValue.bottom, type === "padding" ? theme.pb : theme.mb);
    var effectiveLeft = resolveValue(editedValue.left, type === "padding" ? theme.pl : theme.ml);
    return (_jsx(_Fragment, { children: _jsxs("div", { children: [" ", _jsxs("div", __assign({ className: "flex flex-row" }, { children: [_jsx("div", __assign({ className: "ml-1" }, { children: _jsx(SpacingUnit, { value: "top", getValue: getValue, defaultValue: editedValue.top, placeholderValue: effectiveTop }) })), _jsx("div", __assign({ className: "ml-1" }, { children: _jsx(SpacingUnit, { value: "right", getValue: getValue, defaultValue: editedValue.right, placeholderValue: effectiveRight }) })), _jsx("div", __assign({ className: "ml-1" }, { children: _jsx(SpacingUnit, { value: "bottom", getValue: getValue, defaultValue: editedValue.bottom, placeholderValue: effectiveBottom }) })), _jsx("div", __assign({ className: "ml-1" }, { children: _jsx(SpacingUnit, { value: "left", getValue: getValue, defaultValue: editedValue.left, placeholderValue: effectiveLeft }) }))] }))] }) }));
};
